import React from "react";
import styles from "./hero-section-v2.module.css"
import CTAButton from "../../../v2/common/CTA-Button/cta-button";

interface HeroSectionV2Props {
  backgroundImage: string; // e.g. "/images/home-hero.jpg"
  title: string;
  highlight: string;
  description: string;
}

const HeroSectionV2: React.FC<HeroSectionV2Props> = ({
                                                       backgroundImage,
                                                       title,
                                                       highlight,
                                                       description,
                                                     }) => {
  return (
      <section
          className={styles.hero}
        //   style={{
        //     backgroundImage: `
        //   linear-gradient(to right, rgba(7, 28, 61, 0.9) 40%, rgba(7, 28, 61, 0.4)),
        //   url(${backgroundImage})
        // `,
        //   }}
          style={{
              backgroundImage: `url(${backgroundImage})`,
          }}
      >
        <div className={styles.heroContent}>
          <h1>
            {title}
            <br/>
            <span className={styles.highLight}>{highlight}</span>
          </h1>
          <p><span className={styles.highLight}>{highlight}</span>{description}</p>
            <div className={styles.buttons}>
                {/*<button  className={styles.btnPrimary}>Get Started</button>*/}
                {/*<button className={styles.btnOutline}>Learn More</button>*/}
                <a href="/contact" className={styles.btnPrimary}>
                    Get Started
                </a>
                <a href="/about" className={styles.btnOutline}>
                    Learn More
                </a>
            </div>
        </div>
      </section>
  );
};

export default HeroSectionV2;
